/* eslint-disable import/no-cycle */
import home from './home'
import appsAndPages from './apps-and-pages'
import admin from './admin'
import coordinador from './coordinador'
import reports from './reports'

export default [...home, ...appsAndPages, ...admin, ...coordinador, ...reports]
